import { Injectable } from '@angular/core';
import { Users } from '@etoh/database/angular';

import { SelectOptions } from '@etoh/database/core';
import { map, Observable } from 'rxjs';
import { getSelectOptions } from '../dynamic-form/utilities';
import { StoreService } from './store.service';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private storeService: StoreService) {}

  getBrokersForOptions$(
    officeId: number | null = null
  ): Observable<SelectOptions[]> {
    return this.storeService.store.users.data$.pipe(
      map((users: Users[]) => {
        return users.filter((user) => user.role === 'user');
      }),
      map((users) => {
        if (officeId) {
          users = users.filter((user) => user.officeId === officeId);
        }

        return this.getUsersForOptions(users);
      })
    );
  }

  getGuestsForOptions$(
    officeId: number | null = null
  ): Observable<SelectOptions[]> {
    return this.storeService.store.users.data$.pipe(
      map((users: Users[]) => {
        return users.filter((user) => user.role === 'guest');
      }),
      map((users) => {
        if (officeId) {
          users = users.filter((user) => user.officeId === officeId);
        }

        return this.getUsersForOptions(users);
      })
    );
  }

  getUsersForOptions$(
    officeId: number | null = null
  ): Observable<SelectOptions[]> {
    return this.storeService.store.users.data$.pipe(
      map((users) => {
        if (officeId) {
          users = users.filter((user) => user.officeId === officeId);
        }

        return this.getUsersForOptions(users);
      })
    );
  }

  getUsersForOptions(users: Users[]): SelectOptions[] {
    return getSelectOptions(users, this.getLabelForUser, 'id');
  }

  getLabelForUser(user: Users): string {
    if (!user) {
      return '';
    }
    return `${user.firstname} ${user.lastname}`;
  }
}
